import { React, useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../components/MainHeader/MainHeader'
import MainFooter from '../../components/MainFooter/MainFooter'
import MarkdownDoc from '../../components/MarkdownDoc/MarkdownDoc'

import '../../main.css'
import './Faq.css'
import './MFaq.css'

const DOC_BASE = (process.env.PUBLIC_URL || '') + '/docs'
const DOC_SRC = DOC_BASE + '/Benutzerhandbuch.md'
const SCROLL_SHOW_AFTER = 400

export default function Faq() {
    const [showScrollTop, setShowScrollTop] = useState(false)

    useEffect(() => {
        function onScroll() {
            setShowScrollTop(window.scrollY > SCROLL_SHOW_AFTER)
        }
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <div className='mainCon page faq-root' id='mainCon'>
            <Helmet>
                <title>FAQ &amp; Handbuch – Helferzeit</title>
                <meta name="description" content="Benutzerhandbuch und FAQ zur Helferzeit-WebApp: Anmeldung, Wunschdienste, Profil und Event-Verwaltung." />
            </Helmet>
            <MainHeader pagetitle="" hideProfile={false} hideMenu={false} />
            <main className='page-body faq-page'>
                <section className='container section faq-section'>
                    <header className='faq-head'>
                        <p className='faq-eyebrow'>Hilfe</p>
                        <h1>FAQ &amp; Benutzerhandbuch</h1>
                        <p className='faq-lead'>
                            Schritt-für-Schritt-Erklärung für Helfer:innen und Organisator:innen – in ruhiger, verständlicher Sprache.
                        </p>
                    </header>
                    <div className='faq-doc-card'>
                        <MarkdownDoc
                            src={DOC_SRC}
                            imageBase={DOC_BASE + '/'}
                            className="faq-markdown"
                            showToc={true}
                            tocTitle="Inhalt"
                            showSearch={true}
                            searchPlaceholder="Suchen… z. B. Passwort, Absage, Warteliste"
                        />
                    </div>
                </section>
            </main>
            <MainFooter />

            <button
                type="button"
                className={'faq-scroll-top' + (showScrollTop ? ' is-visible' : '')}
                onClick={scrollToTop}
                aria-label="Nach oben scrollen"
                tabIndex={showScrollTop ? 0 : -1}
            >
                <FontAwesomeIcon icon={faArrowUp} />
            </button>
        </div>
    )
}
